import { render, staticRenderFns } from "./UnmarkedOrdersTab.vue?vue&type=template&id=3cf4a818&scoped=true"
import script from "./UnmarkedOrdersTab.vue?vue&type=script&lang=js"
export * from "./UnmarkedOrdersTab.vue?vue&type=script&lang=js"
import style0 from "./UnmarkedOrdersTab.vue?vue&type=style&index=0&id=3cf4a818&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cf4a818",
  null
  
)

export default component.exports